import React from "react";
import "./App.scss";
import Main from "./containers/Main";

// this is tha main app component
function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
